// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"5d6d2324","830":"5d6d2324"}[chunkId] + ".chunk.css";
};